import { visit } from "unist-util-visit";
import type { Root } from "mdast";

/**
 * Turns `:mark{type=long-only}` into the card icon it describes.
 *
 * The marks section of the backtest article explains icons the reader is
 * looking at on another page, so it has to show them. Rendering the real
 * components rather than exported SVGs means the palette and the geometry stay
 * in one place — a redrawn card icon reaches the help centre with it.
 */
interface DirectiveNode {
  type: string;
  name?: string;
  attributes?: Record<string, string | null | undefined> | null;
  data?: {
    hName?: string;
    hProperties?: Record<string, unknown>;
  };
}

export function remarkMarks() {
  return (tree: Root) => {
    visit(tree, (node) => {
      const directive = node as DirectiveNode;
      if (
        directive.type !== "textDirective" &&
        directive.type !== "leafDirective"
      ) {
        return;
      }
      if (directive.name !== "mark") return;

      // data-* rather than bare props: they survive the hast-to-React hop on an
      // element name React has never heard of, whatever else gets filtered.
      directive.data = {
        ...directive.data,
        hName: "help-mark",
        hProperties: {
          "data-mark": directive.attributes?.type ?? "",
          "data-label": directive.attributes?.label ?? "",
        },
      };
    });
  };
}
